"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _chunkTPZR5EWLjs = require('./chunk-TPZR5EWL.js');

var _chunkJDO43VGYjs = require('./chunk-JDO43VGY.js');

require('./chunk-FKBTJYRF.js');

require('./chunk-P4KLBECR.js');

require('./chunk-NESC3UD7.js');

require('./chunk-6R5OOOHC.js');

require('./chunk-R4XHR6A7.js');

require('./chunk-OUWZ2PU5.js');

exports.BodyPrimary = _chunkTPZR5EWLjs.g;
exports.BodySecondary = _chunkTPZR5EWLjs.h;
exports.Caption = _chunkTPZR5EWLjs.k;
exports.H1 = _chunkTPZR5EWLjs.a;
exports.H2 = _chunkTPZR5EWLjs.b;
exports.H3 = _chunkTPZR5EWLjs.c;
exports.H4 = _chunkTPZR5EWLjs.d;
exports.H5 = _chunkTPZR5EWLjs.e;
exports.H6 = _chunkTPZR5EWLjs.f;
exports.LabelMini = _chunkTPZR5EWLjs.j;
exports.LabelStrong = _chunkTPZR5EWLjs.i;
exports.baseTextStyles = _chunkJDO43VGYjs.a;